"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var VideoController = /** @class */ (function (_super) {
    __extends(VideoController, _super);
    function VideoController(editor, store, props) {
        var _this = _super.call(this, editor, store) || this;
        _this.toolbar = {
            className: 'video',
            tooltip: 'video',
            icon: '',
            handler: function () { return _this.fileInput.click(); }
        };
        _this.uploadVideo = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.reject('please provide uploader in controllerProps for video')];
        }); }); };
        _this.onChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var target, index, attrs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        target = e.target;
                        if (!target.files)
                            return [2 /*return*/];
                        index = this.editor.getSelection().index;
                        return [4 /*yield*/, this.uploadVideo(target.files[0], this.editor)];
                    case 1:
                        attrs = _a.sent();
                        if (!attrs)
                            return [2 /*return*/];
                        this.editor.insertCard('video', attrs, index);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.editorWillUnmount = function () {
            _this.editor.root.removeChild(_this.fileInput);
        };
        if (props.uploader)
            _this.uploadVideo = props.uploader;
        _this.fileInput = tools_1.createFileInput({
            multiple: false,
            accept: props.accept || 'video/*',
            onChange: _this.onChange,
            getContainer: function () { return editor.root; }
        });
        return _this;
    }
    return VideoController;
}(core_utilities_1.SylController));
exports.VideoController = VideoController;
var getVideoConfiguration = function (props) {
    if (props === void 0) { props = {}; }
    var config = {
        tagName: function () { return 'video'; },
        name: 'video',
        attrs: {
            src: {
                default: ''
            },
            width: {
                default: 375
            },
            height: {
                default: ''
            }
        },
        parseDOM: [
            {
                tag: 'p',
                getAttrs: function (dom) {
                    var video = dom.querySelector('video');
                    if (video && dom.parentElement) {
                        dom.nextElementSibling
                            ? dom.parentElement.insertBefore(video, dom.nextElementSibling)
                            : dom.parentElement.appendChild(video);
                    }
                    return false;
                }
            },
            {
                tag: 'video',
                getAttrs: function (dom) {
                    var src = dom.src;
                    if (!src) {
                        var source = dom.querySelector('source');
                        if (!source)
                            return false;
                        src = source.src;
                    }
                    if (!src)
                        return false;
                    var formattedAttrs = {
                        src: src,
                        width: dom.width || undefined,
                        height: dom.height || undefined
                    };
                    tools_1.getFromDOMByConfig(props.addAttributes, dom, formattedAttrs);
                    return formattedAttrs;
                }
            }
        ],
        toDOM: function (node) {
            var attrs = __assign({}, node.attrs);
            tools_1.setDOMAttrByConfig(props.addAttributes, node, attrs);
            return ['video', attrs];
        }
    };
    tools_1.addAttrsByConfig(props.addAttributes, config.attrs);
    return config;
};
exports.getVideoConfiguration = getVideoConfiguration;
//# sourceMappingURL=video.js.map